import { stdObject } from "../../../data/types/stdObject";

export const openDownloadModal = (
  download: stdObject,
  { t, setMsg, setModalData }: stdObject,
) => {
  console.log("openDownloadModal", download);
  switch (download.internet) {
    case "ok":
      break;
    case "noAccess":
      setMsg("custom1");
      setModalData({ code: "error", label: t("p.noAccess") });
      break;
    default:
      setMsg("custom1");
      setModalData({ code: "error", label: t("p.error") });
      break;
  }
};
